<template>
    <div id="user-list">
        <div v-if="isLoaded" class="row">
            <template v-if="users.length > 0">
                <b-list-group class="col-6">
                    <b-list-group-item
                        v-for="(user,userkey) in users"
                        :key="userkey"
                        :class="{ 'active': userkey === selectedUser }"
                        @click="selectedUser = userkey">
                        <strong>{{ user.userId }}</strong><br>{{ user.email }}<br>{{ user.backendId }}
                    </b-list-group-item>
                </b-list-group>

                <b-card
                    v-if="selectedUser || selectedUser === 0"
                    class="col-6"
                    :title="users[selectedUser].name"
                >
                    <b-card-text>
                        <p>
                            <font-awesome-icon v-if="parseInt(users[selectedUser].userLevel) === 2" icon="user-cog"/>
                            <font-awesome-icon v-else icon="user"/>
                            {{ users[selectedUser].userId }}
                        </p>
                        <p>
                            <font-awesome-icon icon="envelope"/>
                            {{ users[selectedUser].email }}
                        </p>

                        <hr>
                        <form v-if="username === users[selectedUser].userId">
                            <div class="form-group">
                                <label>{{ $t("user.oldPassword") | capitalize-first }}</label>
                                <input type="password" class="form-control" v-model="passwordChange.old">
                            </div>
                            <div class="form-group">
                                <label>{{ $t("user.password") | capitalize-first }}</label>
                                <input type="password" class="form-control" v-model="passwordChange.new">
                            </div>
                            <button class="btn btn-primary" @click.prevent="changePassword"
                                :disabled="passwordChange.old <= 0 || passwordChange.new <= 0">
                                {{ $t("manager.users.changePassword") }}
                            </button>
                        </form>
                    </b-card-text>
                </b-card>
            </template>
            <template v-else>
                <div class="alert alert-warning">
                    {{ $t("noRows") }}
                </div>
            </template>
            <div class="col-12" v-if="isAdmin">
                <hr>
                <form>
                    <div class="form-group">
                        <label>{{ $t("user.username") | capitalize-first }}</label>
                        <input type="text" class="form-control" v-model="newUser.userId">
                    </div>
                    <div class="form-group">
                        <label>{{ $t("user.password") | capitalize-first }}</label>
                        <input type="password" class="form-control" v-model="newUser.password">
                    </div>
                    <br>
                    <div class="form-group">
                        <label>{{ $t("user.email") | capitalize-first }}</label>
                        <input type="email" class="form-control" v-model="newUser.email">
                    </div>
                    <div class="form-group">
                        <label>{{ $t("manager.company.common.title") | capitalize-first }}</label>
                        <input type="text" class="form-control" v-model="newUser.backendId">
                    </div>
                    <div class="form-group">
                        <label class="mr-2">{{ $t("user.userLevel") | capitalize-first }}</label>
                        <div class="btn-group" role="group">
                            <button @click.prevent="setNewUserLevel(1)" type="button" class="btn btn-primary" :class="{'active' : newUser.userLevel === 1}">{{ $t("user.userLevelNormal") | capitalize-first }}</button>
                            <button @click.prevent="setNewUserLevel(2)" type="button" class="btn btn-primary" :class="{'active' : newUser.userLevel === 2}">{{ $t("user.userLevelAdmin") | capitalize-first }}</button>
                        </div>
                    </div>
                    <button class="btn btn-primary" @click.prevent="addNewUser"
                        :disabled="newUser.userId.length <= 0 || newUser.password.length <= 0 || newUser.email.length <= 0 || newUser.backendId.length <= 0">
                        {{ $t("manager.users.addNew") }}
                    </button>
                </form>
            </div>
        </div>
        <div v-else class="m-3 p-3 border rounded">
            <div class="text-center">
                <font-awesome-icon icon="spinner" pulse />
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'UserList',
  data () {
    return {
      isLoaded: false,
      users: [],
      selectedUser: null,
      newUser: {
        userId: '',
        password: '',
        email: '',
        backendId: '',
        userLevel: 1
      },
      passwordChange: {
        old: '',
        new: ''
      }
    }
  },
  computed: {
    isAdmin () {
      return this.$store.getters.isAdmin
    },
    username () {
      return this.$store.getters.getUser.username
    }
  },
  methods: {
    setNewUserLevel: function (userLevel) {
      this.newUser.userLevel = userLevel
    },
    addNewUser: function () {
      let me = this
      axios.put(me.$store.getters.urlPath + 'services/manager/createUser.php', {
        userId: me.newUser.userId,
        password: me.newUser.password,
        email: me.newUser.email,
        backendId: me.newUser.backendId,
        userLevel: me.newUser.userLevel
      })
        .then((response) => {
          me.users.push(me.newUser)
          me.newUser = {
            userId: '',
            password: '',
            email: '',
            backendId: '',
            userLevel: 1
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
        })
    },
    loadUserList: function () {
      let me = this
      axios.get(me.$store.getters.urlPath + 'services/manager/getUserList.php')
        .then(function (response) {
          me.users = response.data
          me.isLoaded = true
        })
        .catch(function (error) {
          // eslint-disable-next-line
          console.log(error)
        })
    },
    changePassword: function () {
      let me = this
      axios.put(me.$store.getters.urlPath + 'services/manager/changePassword.php', {
        userId: me.users[me.selectedUser].userId,
        backendId: me.users[me.selectedUser].backendId,
        passwordOld: me.passwordChange.old,
        passwordNew: me.passwordChange.new
      })
        .then((response) => {
          me.passwordChange.old = ''
          me.passwordChange.new = ''
        })
        .catch(function (error) {
          // eslint-disable-next-line
          console.log(error)
        })
    }
  },
  mounted () {
    this.loadUserList()
  }
}
</script>

<style lang="scss">
#user-list .list-group > .list-group-item:hover {
    cursor: pointer;
}
</style>
